
module.exports = {
  name: 'bounceOutUp',
  option: {
    duration: '1s',
    mode: 'both'
  },
  timeline: {
    '20%': {
      transform: 'translate3d(0, -10px, 0)'
    },
    '40%, 45%': {
      opacity: '1',
      transform: 'translate3d(0, 20px, 0)'
    },
    to: {
      opacity: '0',
      transform: 'translate3d(0, -2000px, 0)'
    }
  }
};



// WEBPACK FOOTER //
// ./lib/ctr-nodes/preset/animation/animate.css/bounceOutUp.js